// src/router/index.js
import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  // 0. Welcome
  {
    path: "/",
    name: "welcome",
    meta: {
      videoPath: "/video/teaser.mp4",
      vignetteGrade: 3,
    },
    component: () => import("@/views/Welcome.vue"),
  },

  {
    path: "/the-barrier",
    name: "barrier",
    component: () => import("@/views/Barrier.vue"),
  },

  {
    path: "/opportunity",
    name: "opportunity",
    component: () => import("@/views/Opportunity.vue"),
  },

  {
    path: "/vision",
    name: "vision",
    component: () => import("@/views/Vision.vue"),
  },
  {
    path: "/technology",
    name: "technology",
    component: () => import("@/views/Technology.vue"),
  },
  {
    path: "/the-process",
    name: "the-process",
    component: () => import("@/views/TheProcess.vue"),
  },
  {
    path: "/cineself-suite",
    component: () => import("@/views/ParentView.vue"),
    children: [
      {
        path: "",
        name: "suite.overview",
        component: () => import("@/views/suite/CineselfSuite.vue"),
      },
      {
        path: "casting",
        name: "suite.casting",
        component: () => import("@/views/suite/CineselfCasting.vue"),
      },
      {
        path: "stream",
        name: "suite.stream",
        component: () => import("@/views/suite/CineselfStream.vue"),
      },
      {
        path: "productions",
        name: "suite.productions",
        component: () => import("@/views/suite/CineselfProductions.vue"),
      },
    ],
  },
  {
    path: "/moenetization",
    component: () => import("@/views/ParentView.vue"),
    children: [
      {
        path: "",
        name: "monetization.overview",
        component: () => import("@/views/monetization/Overview.vue"),
      },
      {
        path: "",
        name: "monetization.blockchain",
        component: () => import("@/views/monetization/Blockchain.vue"),
      },
      {
        path: "",
        name: "monetization.tokens",
        component: () => import("@/views/monetization/Tokens.vue"),
      },
    ],
  },

  {
    path: "/advantages",
    component: () => import("@/views/Advantages.vue"),
  },

  // 9. The team
  {
    path: "/team",
    component: () => import("@/views/ParentView.vue"),
    children: [
      {
        path: "",
        name: "team",
        component: () => import("@/views/team/TeamOverview.vue"),
      },
      {
        path: "victor",
        name: "team.victor",
        component: () => import("@/views/team/Victor.vue"),
      },
      {
        path: "phil",
        name: "team.phil",
        component: () => import("@/views/team/Phil.vue"),
      },
      {
        path: "Philip",
        name: "team.philip",
        component: () => import("@/views/team/Philip.vue"),
      },
      {
        path: "Jeff",
        name: "team.jeff",
        component: () => import("@/views/team/Jeff.vue"),
      },
    ],
  },

  // 11. The ask
  {
    path: "/ask",
    name: "the-ask",
    component: () => import("@/views/Ask.vue"),
  },

  // 12. Thank you
  {
    path: "/thank-you",
    name: "thank-you",
    meta: {
      videoPath: "/video/thanks-video.mp4",
      vignetteGrade: 3,
    },
    component: () => import("@/views/ThankYou.vue"),
  },
];

let router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

// helper to turn a route “name” into a human-friendly title
function formatTitle(name) {
  return name
    .split(".") // [ "automation-age", "timeline" ]
    .map((seg) =>
      seg
        .split("-") // [ "automation", "age" ]
        .map((word) => word[0].toUpperCase() + word.slice(1))
        .join(" ")
    )
    .join(" – "); // => "Automation Age – Timeline"
}

// after *every* successful navigation…
router.afterEach((to) => {
  const name = to.name || "";
  document.title = name ? formatTitle(name) : "HostGarden - Presentation";
});

export default router;
